const routes = {
  URL_WITHOUT_LAYOUT: '',
  URL_LOGIN: '/tucodigo',
  URL_HOME: '/orders',
};

export default routes;
